import styled from "styled-components";

export const Body = styled.div`
    padding: 24px 24px 0 24px;
`